export class Resolvable {
    constructor(reference, _value) {
        this.reference = reference;
        this._value = _value;
    }
    get isResolved() {
        return !!this._value;
    }
    get value() {
        if (!this._value)
            throw new Error('Value not resolved');
        return this._value;
    }
    async dereference(resolver) {
        if (!this._value) {
            this._value = await resolver(this.reference);
        }
    }
}
export class ResolvableAndAdaptable {
    constructor(reference, adapter, _value) {
        this.reference = reference;
        this.adapter = adapter;
        this._value = _value;
    }
    get isResolved() {
        return !!this._value;
    }
    get value() {
        if (!this._value)
            throw new Error('Value not resolved');
        return this._value;
    }
    async dereference(resolver) {
        if (!this._value) {
            const schema = await resolver(this.reference);
            this._value = this.adapter(schema);
        }
    }
}
//# sourceMappingURL=resolvable.js.map